import { useState, useEffect } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { createPortal } from "react-dom";
import { Link, useLocation, useNavigate } from "react-router-dom";

const overlayStyles = {
  position: "fixed",
  inset: "0",
  zIndex: "40",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  backdropFilter: "blur(3px)",
  WebkitBackdropFilter: "blur(3px)",
};

function MiddleButtons({ isMobile }) {
  const navigate = useNavigate();

  return (
    <div className={isMobile ? "flex flex-col gap-2" : "flex"}>
      <button
        onClick={() => navigate("/")}
        className={`p-2 text-xs font-semibold ${
          isMobile ? "text-black w-full" : "text-black md:text-white mr-14 p-0"
        }`}
        style={{ background: "transparent" }}
      >
        Home
      </button>

      <button
        className={`p-2 text-xs font-semibold ${
          isMobile ? "text-black w-full" : "text-black md:text-white mr-14 p-0"
        }`}
        style={{ background: "transparent" }}
      >
        Pricing
      </button>

      <button
        className={`p-2 text-xs font-semibold ${
          isMobile ? "text-black w-full" : "text-black md:text-white p-0"
        }`}
        style={{ background: "transparent" }}
      >
        Join us
      </button>
    </div>
  );
}

function RightButtons({ isMobile }) {
  const navigate = useNavigate();

  return (
    <div className={isMobile ? "flex flex-col gap-2" : "flex"}>
      <div
        className={`px-4 py-2 text-xs text-center font-semibold rounded-md cursor-pointer ${
          isMobile ? "w-full" : "mr-2 px-4 py-1.5"
        }`}
        style={{ background: "rgba(202,195,237,0.42)" }}
        onClick={() => navigate("/login")}
      >
        Login
      </div>
      <div
        className={`px-4 py-2 text-xs text-center font-semibold rounded-md text-white cursor-pointer ${
          isMobile ? "w-full" : "px-5 py-1.5"
        }`}
        style={{ background: "var(--color-primary)" }}
        onClick={() => navigate("/register")}
      >
        Get Started
      </div>
    </div>
  );
}

function Overlay({ isOpen, onClose, children }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div style={overlayStyles} onClick={onClose}>
      {children}
    </div>,
    document.body
  );
}

function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const isNotHome = location.pathname !== "/";
  const isAuthenticated = localStorage.getItem("isAuthenticated");
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <header
        className="top-0 left-0 w-full z-50 pt-4 pb-3 bg-white md:bg-transparent"
        style={{
          backgroundColor: isNotHome ? "rgba(38, 22, 119)" : undefined,
          position: isNotHome ? "relative" : "absolute",
        }}
      >
        <div className="container mx-auto px-4 md:px-6 lg:px-8 flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => navigate("/")}>
            <img src="/logo.svg" alt="Logo" className="h-8" />
          </div>

          <div className="hidden md:flex justify-center text-black md:text-white">
            <MiddleButtons isMobile={false} />
          </div>

          {isAuthenticated ? (
            <Link
              to="/chat"
              className="hidden md:inline-block px-4 py-2 text-xs text-center font-semibold rounded-md text-white cursor-pointer"
              style={{
                background: "var(--color-primary)",
              }}
            >
              Back to Chat
            </Link>
          ) : (
            <div className="hidden md:flex text-black md:text-white">
              <RightButtons isMobile={false} />
            </div>
          )}

          <div className="md:hidden">
            <div onClick={toggleMenu} className="p-0 cursor-pointer">
              {menuOpen ? (
                <FiX
                  size={24}
                  color={isNotHome ? "white" : "var(--color-primary)"}
                />
              ) : (
                <FiMenu
                  size={24}
                  color={isNotHome ? "white" : "var(--color-primary)"}
                />
              )}
            </div>
          </div>
        </div>
      </header>

      <Overlay isOpen={menuOpen} onClose={closeMenu}>
        <div className="md:hidden mt-2 flex flex-col gap-2 w-1/2 p-4 absolute top-12 right-4 sm:right-10 shadow-lg rounded-b-md bg-white">
          <MiddleButtons isMobile={true} />{" "}
          {isAuthenticated ? (
            <Link
              to="/chat"
              className="px-4 py-2 text-xs text-center font-semibold rounded-md text-white cursor-pointer"
              style={{
                background: "var(--color-primary)",
              }}
            >
              Back to Chat
            </Link>
          ) : (
            <RightButtons isMobile={true} />
          )}
        </div>
      </Overlay>
    </>
  );
}

export default Header;
